var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"section-title",attrs:{"data-external":"section-title"}},[_c('BaseHeading',{staticClass:"section-title__heading",attrs:{"level":_vm.headingLevel,"title":_vm.title}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }